<template>
    <aside class="perks-widget__cats">
        <h2>Categories</h2>
        <ul>
            <li
                v-for="parentCategory in categories"
                :key="parentCategory.category_id"
            >
                <a
                    href="#"
                    @click.prevent="showOffers(parentCategory)"
                >
                    {{ parentCategory.main_cat }}
                </a>

                <ul v-if="parentCategory.children && parentCategory.children.length">
                    <li
                        v-for="childCategory in parentCategory.children"
                        :key="childCategory.category_id"
                    >
                        <a
                            href="#"
                            @click.prevent="showOffers(childCategory)"
                        >
                            {{ childCategory.sub_cat }}
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </aside>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'categories'
        ])
    },
    created () {
        this.getCategories();
    },
    mounted () {
        this.getOffers({ id: 322 });
    },
    methods: {
        ...mapActions([
            'getCategories',
            'getOffers'
        ]),
        showOffers (category) {
            this.getOffers({ id: category.category_id });
        }
    }
};
</script>
